import { useLayoutEffect, useState } from 'react';

export default function useFetchJSONContent<T>(url: string, item: string) {
  const [data, setData] = useState<T>();

  async function fetchData(NewURL: string) {
    try {
      const response = await fetch(NewURL);

      if (!response.ok) {
        throw new Error(`Erro HTTP! Status: ${response.status}`);
      }

      const jsonData = await response.json();
      setData(jsonData);
    } catch (error) {
      console.error('Erro ao buscar o JSON:', error);
    }
  }

  useLayoutEffect(() => {
    fetchData(url);
  }, [item]);

  return data;
}
